export default "__VITE_ASSET__5d316bf0__"